import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from 'redux-thunk';
import * as reducers from '../src/all-reducers';

export default function rootReducerAndStore() {
    const isProd=true;
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const rootReducer = combineReducers(reducers);
    if(isProd) {
        return createStore(rootReducer, applyMiddleware(thunk));
    }

    return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
}